import { CSSProperties } from 'react';
import styles from './Skills.module.scss';

const RING_RADIUS = 34;

interface RingWrapperStyle extends CSSProperties {
  '--circ': number;
}

// Owns --circ so each instance can use a different radius
const RingChart = ({ level, radius = RING_RADIUS }: { level: number; radius?: number }) => {
  const dim = radius * 2 + 8;
  const half = dim / 2;
  const circ = +(2 * Math.PI * radius).toFixed(2);
  return (
    <div className={styles.ringWrapper} style={{ '--circ': circ } as RingWrapperStyle}>
      <svg viewBox={`0 0 ${dim} ${dim}`} width={dim} height={dim} aria-hidden='true'>
        <circle cx={half} cy={half} r={radius} className={styles.ringTrack} />
        <circle cx={half} cy={half} r={radius} className={styles.ring} />
      </svg>
      <span className={styles.ringLabel}>{level}%</span>
    </div>
  );
};

export default RingChart;
